import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { siteConfig } from '../../config/site';

const Wrap = styled.section`
  padding: 4rem 1rem;
`;

const Grid = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.5rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    text-align: center;
  }
`;

const Copy = styled.div`
  h2 {
    font-size: clamp(1.5rem, 3vw, 2rem);
    margin: 0 0 1rem;
    color: var(--text-color);
  }
  p {
    color: var(--text-secondary);
    line-height: 1.75;
    margin-bottom: 1rem;
  }
`;

const CTAButton = styled(Link)`
  display: inline-block;
  margin-top: 0.75rem;
  background: var(--primary-color);
  color: var(--text-color);
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  text-decoration: none;
  transition: transform 0.2s ease;
  &:hover { transform: translateY(-2px); }
`;

const Panel = styled.aside`
  background: var(--background-light);
  border-radius: var(--border-radius);
  padding: 2rem;
  box-shadow: var(--box-shadow);

  h3 {
    margin: 0 0 0.5rem;
    color: var(--text-color);
    font-size: 1.15rem;
  }
  p {
    color: var(--text-secondary);
    margin: 0 0 1.25rem;
    line-height: 1.6;
    font-size: 0.95rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    padding: 0.5rem 0;
    border-top: 1px solid rgba(255,255,255,0.06);
    color: var(--text-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  li:first-child { border-top: none; }
  li a { color: var(--primary-color); text-decoration: none; font-size: 0.9rem; }
  li a:hover { text-decoration: underline; }
`;

const AboutStrip: React.FC = () => (
  <Wrap>
    <Grid>
      <Copy>
        <h2>About {siteConfig.brand.name}</h2>
        <p>
          {siteConfig.brand.name} is a resource for anyone working with USDT flashing
          technology and the wider stablecoin economy. We publish plain-language
          guides on how flash transactions work, security best practices, blockchain
          fundamentals, and practical tutorials for developers and traders.
        </p>
        <p>
          New articles are published regularly — subscribe to the blog or bookmark
          this page to follow along.
        </p>
        <CTAButton to="/blog">Read the blog</CTAButton>
      </Copy>

      <Panel>
        <h3>Quick links</h3>
        <p>Popular starting points on the site.</p>
        <ul>
          <li>Documentation <Link to="/documentation">Open →</Link></li>
          <li>Tutorials <Link to="/tutorials">Open →</Link></li>
          <li>Support <Link to="/support">Open →</Link></li>
          <li>Contact <Link to="/contact">Open →</Link></li>
        </ul>
      </Panel>
    </Grid>
  </Wrap>
);

export default AboutStrip;
